import { Inline } from '@shared/layout/Inline'
import { Footer } from '@shared/layout/DefaultPage'
import React, { FC } from 'react'
import { BlueTransparentButton } from '@shared/styles/BlueTransparentButton'
import { observer } from 'mobx-react-lite'
import { workoutExecutionStore } from '@features/workout/execution/workoutExecutionStore'
import {
	WorkoutHistoryProxy,
	scheduleTrainingListsInvalidation,
} from '@entities/training'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface FooterProps {
	onClick: () => void | Promise<void>
	exerciseOrder: number
	workoutHistoryId: number
}

export const StrengthExerciseFooter: FC<FooterProps> = observer(
	({ onClick, exerciseOrder, workoutHistoryId }) => {
		const { exercisesAmount } = workoutExecutionStore
		const queryClient = useQueryClient()

		const finishTrainingMutation = useMutation({
			mutationFn: () => WorkoutHistoryProxy.finishTraining(workoutHistoryId),
			onSuccess: () => {
				scheduleTrainingListsInvalidation(queryClient)
			},
		})

		const handleClick = async () => {
			try {
				await Promise.resolve(onClick())

				if (exerciseOrder === exercisesAmount) {
					setTimeout(() => {
						finishTrainingMutation.mutate()
					}, 500)
				}
			} catch (error) {
				console.error('Error in button click handler:', error)
			}
		}

		return (
			<Footer>
				<Inline justify={'center'}>
					<BlueTransparentButton
						width={230}
						height={40}
						onClick={handleClick}
						disabled={finishTrainingMutation.isPending}>
						{exerciseOrder !== exercisesAmount
							? 'Завершить упражнение'
							: finishTrainingMutation.isPending
								? 'Завершаем...'
								: 'Завершить тренировку'}
					</BlueTransparentButton>
				</Inline>
			</Footer>
		)
	}
)
